import Model from '@/store/model';
import Thematics from './thematics'; /* eslint-disable-line */
import BadgeInfo from './badge_info'; /* eslint-disable-line */
import LastLearnedInfo from './last_learned_info'; /* eslint-disable-line */
import BonusLessons from './bonus_lessons'; /* eslint-disable-line */

class ThematicByLevelResponse extends Model {
  map(json) {
    super.map(json);
    this.mapArray('thematics', json.thematics, Thematics);
    this.mapArray('bonusLessons', json.bonus_lessons, BonusLessons);

    if (json.badge_info !== undefined && json.badge_info !== null) {
      this.badgeInfo = new BadgeInfo();
      this.badgeInfo.map(json.badge_info);
    }

    if (json.last_learned_info !== undefined && json.last_learned_info !== null) {
      this.lastLearnedInfo = new LastLearnedInfo();
      this.lastLearnedInfo.map(json.last_learned_info);
    }
  }
}
export default ThematicByLevelResponse;
